import { ConfigSentryF } from '../../../Config/Sentry/F/Function/module/ConfigSentryF.js';

export const sentryError = (e, { tags, option, extra } = {}) => {
  ConfigSentryF.error(e, { tags: { ...tags, project_name: 'ness-labs' }, option, extra });
};
